// app/javascript/controllers/thank_you_controller.js
import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"
import * as bootstrap from "bootstrap"

export default class extends Controller {
    static targets = ["fileInput", "uploadIcon", "uploadText", "preview"]
    static values  = { uploadUrl: String } // <- no previewUrl

    // 1) Upload immediately when file changes
    fileChanged() {
        const file = this.fileInputTarget?.files?.[0]
        if (!file) return

        const fd    = new FormData()
        const token = document.querySelector('meta[name="csrf-token"]')?.content || ""
        fd.append("image", file)
        fetch(this.uploadUrlValue, {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "X-CSRF-Token": token
            },
            body: fd
        })
            .then(r => {
                if (!r.ok) throw new Error("Upload failed")
                return r.json()
            })
            .then(({ url }) => {
                // Update the card UI
                this.uploadIconTarget?.classList.add("d-none")
                if (this.uploadTextTarget) this.uploadTextTarget.textContent = "Change picture"
                if (this.previewTarget && url) {
                    this.previewTarget.src = url
                    this.previewTarget.classList.remove("d-none")
                }
            })
            .catch(err => console.error(err))
    }

    // 2) Preview using Turbo Stream + CSRF, derive URL from form.action
    preview(e) {
        e.preventDefault()

        const form         = document.getElementById("thank_you_form")
        const messageInput = document.getElementById("thank_you_message_html")
        const quill        = window.__quillById ? window.__quillById["ty_editor"] : null
        messageInput.value = quill ? quill.root.innerHTML : ""

        const fd    = new FormData(form)
        const token = document.querySelector('meta[name="csrf-token"]')?.content || ""
        // derive preview URL from the form action (…/thank_you/send -> …/thank_you/preview)
        const previewUrl = form.action.replace("/thank_you/send", "/thank_you/preview")

        fetch(previewUrl, {
            method: "POST",
            headers: {
                "Accept": "text/vnd.turbo-stream.html",
                "X-CSRF-Token": token
            },
            body: fd
        })
            .then(r => r.text())
            .then(html => {
                // Let Turbo process the <turbo-stream> and swap the frame
                (window.Turbo || window.turbo)?.renderStreamMessage(html)

                // Open modal (Bootstrap)
                const modalEl = document.getElementById("tyPreviewModal")
                if (modalEl) bootstrap.Modal.getOrCreateInstance(modalEl).show()
            })
    }

    beforeSend(event) {
        const quill  = window.__quillById ? window.__quillById["ty_editor"] : null
        const hidden = document.getElementById("thank_you_message_html")
        if (hidden) hidden.value = quill ? quill.root.innerHTML : ""
    }

    notifyStart = () => {
        this.beforeSend({}) // ensure hidden field has content
        // Non-blocking toast that tells the host it's OK to navigate around
        Swal.fire({
            title: "Sending your thank-you notes…",
            text: "We’re sending them in the background. It’s safe to keep browsing this page.",
            icon: "info",
            toast: true,
            position: "bottom",       // matches your other toasts
            timer: 6000,
            timerProgressBar: true,
            showConfirmButton: false
        })
    }

    notifyEnd = (event) => {
        const ok = event?.detail?.success === true
        Swal.fire({
            title: ok ? "All set!" : "Something went wrong",
            text: ok ? "Your thank-you notes have been sent." : "Please try again or check your connection.",
            icon: ok ? "success" : "error",
            toast: true,
            position: "bottom",
            timer: 6000,
            timerProgressBar: true,
            showConfirmButton: false
        })
    }

}